import React from "react";
import styles from "./Table.module.scss";
import ArrowIcon from "../../assets/svg/icons/common/arrow";
import useCommonStore from "../../stores/common";

const Table = ({
  layout = "auto",
  columns,
  data,
  sortBy,
  sortColumn,
  onSortClick,
  onRowClick,
  renderExpandedContent,
  selectedRowId = null,
  searching = false,
}) => {
  const showDetails = useCommonStore((state) => state.showDetails);
  const visibleColumns = columns.filter((col) => !col?.hideCell);

  return (
    <div
      className={`${styles.tableContainer} ${layout === "fixed" ? `${styles.fixed} ${showDetails ? styles.detailsVisible : ""}` : ""}`}
    >
      <table className={styles.table}>
        <thead>
          <tr className={styles.headerRow}>
            {columns
              .filter((col) => !col?.hideCell)
              .map((col) => (
                <th
                  key={col.field}
                  className={styles.headerCell}
                  style={{ width: col.width || "auto" }}
                >
                  {col.allowSort ? (
                    <button onClick={() => onSortClick(col.field)}>
                      <span>
                        {col.renderHeader ? col.renderHeader() : col.headerName}
                      </span>
                      <div className={sortColumn === "DESC" ? styles.down : ""}>
                        {sortBy === col.field && <ArrowIcon />}
                      </div>
                    </button>
                  ) : (
                    <>
                      {col.renderHeader ? col.renderHeader() : col.headerName}
                    </>
                  )}
                </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {!data?.length && !searching && (
            <tr>
              <td colSpan={visibleColumns.length}>
                <div className={styles.noData}>
                  <span>No data to display</span>
                </div>
              </td>
            </tr>
          )}

          {!data?.length && searching && (
            <tr>
              <td colSpan={visibleColumns.length}>
                <div className={styles.noData}>
                  <span>No data found</span>
                </div>
              </td>
            </tr>
          )}

          {data &&
            data.map((row, rowIndex) => (
              <React.Fragment key={rowIndex}>
                <tr
                  className={`${styles.row} ${row.expanded ? styles.expanded : ""} ${selectedRowId === row.id ? styles.selectedRow : ""}`}
                  onClick={() => onRowClick?.(row)}
                >
                  {visibleColumns.map((col, idx) => (
                    <td
                      key={col.field}
                      className={styles.cell}
                      style={{ width: col.width || "auto" }}
                    >
                      {col.renderCell
                        ? col.renderCell(row[col.field], row)
                        : row[col.field]}

                      {idx === 0 && selectedRowId === row.id && (
                        <span className={styles.selected} />
                      )}
                    </td>
                  ))}
                </tr>

                {row.expanded && renderExpandedContent && (
                  <tr className={styles.expandedRow}>
                    <td colSpan={visibleColumns.length}>
                      <div className={styles.expandedContent}>
                        {renderExpandedContent(row)}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
